import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground hover:bg-primary-hover',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
        // PEP-VIDA: badges por tipo de documento
        consulta:
          'border-transparent bg-pep-consulta/10 text-pep-consulta hover:bg-pep-consulta/20',
        receita:
          'border-transparent bg-pep-receita/10 text-pep-receita hover:bg-pep-receita/20',
        exame:
          'border-transparent bg-pep-exame/10 text-pep-exame hover:bg-pep-exame/20',
        atestado:
          'border-transparent bg-pep-atestado/10 text-pep-atestado hover:bg-pep-atestado/20',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
